export default __webpack_public_path__ + "static/media/me-(1).0bc0b388.png";